import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigation = [
    { name: 'Productos', href: '#modulos', isRoute: false },
    { name: 'Industrias', href: '#industrias', isRoute: false },
    { name: 'Clientes', href: '#testimonios', isRoute: false },
    { name: 'Recursos', href: '#faq', isRoute: false }
  ];

  const handleNavClick = (e, href, isRoute) => {
    e.preventDefault();
    
    // Si estamos en una página de producto, primero ir al home
    if (location.pathname !== '/') {
      navigate('/');
      // Esperar a que se cargue la página home y luego hacer scroll
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Ya estamos en home, solo hacer scroll
      const element = document.querySelector(href);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
    
    setIsMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-200 ${
        isScrolled 
          ? 'bg-white shadow-sm' 
          : 'bg-black text-white'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_smart-workspaces/artifacts/joupqq6v_logo_blue_horizontal.png" 
                alt="Cloudbase" 
                className={`transition-all duration-200 ${
                  isScrolled ? 'brightness-100' : 'brightness-0 invert'
                }`}
                style={{ height: '5rem' }}
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href, item.isRoute)}
                className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-black' 
                    : 'text-gray-300 hover:text-white'
                }`}
              >
                {item.name}
              </a>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <Button 
              variant="ghost" 
              className="text-sm font-medium text-gray-700 hover:text-black"
            >
              Iniciar Sesión
            </Button>
            <Button 
              className="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-6"
              onClick={() => window.location.href = '/demo'}
            >
              Solicitar Demo
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="container mx-auto px-4 py-4 space-y-1">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href, item.isRoute)}
                className="block px-4 py-3 text-gray-700 hover:text-black font-medium text-sm"
              >
                {item.name}
              </a>
            ))}
            <div className="pt-4 space-y-2 border-t border-gray-200 mt-4">
              <Button variant="outline" className="w-full">
                Iniciar Sesión
              </Button>
              <Button 
                className="w-full bg-green-600 hover:bg-green-700 text-white"
                onClick={() => window.location.href = '/demo'}
              >
                Solicitar Demo
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;